import { render, staticRenderFns } from "./WineThumb.vue?vue&type=template&id=2307c104&scoped=true"
import script from "./WineThumb.vue?vue&type=script&lang=js"
export * from "./WineThumb.vue?vue&type=script&lang=js"
import style0 from "./WineThumb.vue?vue&type=style&index=0&id=2307c104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307c104",
  null
  
)

export default component.exports